// Make planning for the screens: the make dashboard (shared/make.ts) over the plan (lib/planning.ts, which is
// the MRP once BOMs are in) and the synced stock, worked out again only when one of them changes and shared by
// every component that asks; consignment's CM summary (useCms()) supplies reservations, free stock and make orders.
// Also auto mode's latest run, for the summary on the planning pages.
import { type MakeDashboard, makeDashboard } from "../../../shared/make.ts";
import type { Plan } from "../../../shared/planning.ts";
import { useCms } from "../pages/consignment/lib.ts";
import { useBomIndex } from "./boms.ts";
import { usePlan } from "./planning.ts";
import { useRows } from "./sync.ts";

let last: { inputs: unknown[]; dash: MakeDashboard } | null = null;

export function useMakeDashboard(): { plan: Plan; dash: MakeDashboard } {
  const plan = usePlan();
  const inputs = [
    plan,
    useBomIndex(),
    useRows("location"),
    useRows("stock_level"),
    useRows("stock_balance"),
    useRows("vendor"),
    useRows("project"),
    useRows("project_product"),
    useCms(),
  ] as const;
  if (!last || last.inputs.some((x, i) => x !== inputs[i])) {
    const [, boms, locations, stock, balances, vendors, projects, projectProducts, cms] = inputs;
    last = { inputs: [...inputs], dash: makeDashboard({ plan, boms, locations, stock, balances, vendors, projects, projectProducts, cms }) };
  }
  return { plan, dash: last.dash };
}

/** Auto mode's latest run (nightly after the forecast, or "Run now"). */
export function useLastAutoRun() {
  const runs = useRows("plan_run");
  let latest: (typeof runs)[number] | undefined;
  for (const r of runs) if (r.kind === "auto_reorder" && (!latest || r.started_at > latest.started_at)) latest = r;
  return latest;
}
